import gql from 'graphql-tag';

export const ALL_CONDICIONES =gql`
  query allCondiciones{
   allCondiciones
      {
       edges{
        node{
          id
          nombre
        }
      }
      }
  }
`;
